// === Show while scrolling, fade out after stop (except at top)
//     opacityは inline-style で直接制御して確実にトランジションさせる
document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;
  const STOP_DELAY = window.matchMedia('(min-width: 750px)').matches ? 800 : 200;
  let stopTimer = null;

  const logos = Array.from(document.querySelectorAll('.header-item--logo'));
  if (!logos.length) return;

  // 最上部判定
  const setTopClass = () => {
    if (window.scrollY <= 0) root.classList.add('at-top');
    else root.classList.remove('at-top');
  };

  // ロゴ表示/非表示を inline-style で制御（!importantを確実に越える）
  const showLogos = () => { logos.forEach(el => { el.style.opacity = '1'; }); };
  const hideLogos = () => { logos.forEach(el => { el.style.opacity = '0'; }); };

  const onScroll = () => {
    root.classList.add('is-scrolling');
    root.classList.remove('is-stopped');
    setTopClass();

    // スクロール中は常に見せる
    showLogos();

    // 停止判定
    if (stopTimer) clearTimeout(stopTimer);
    stopTimer = setTimeout(() => {
      root.classList.remove('is-scrolling');
      root.classList.add('is-stopped');
      setTopClass();

      // 最上部で停止＝表示、それ以外で停止＝ふわっと非表示
      if (root.classList.contains('at-top')) showLogos();
      else hideLogos();
    }, STOP_DELAY);
  };

  // 初期状態
  setTopClass();
  if (root.classList.contains('at-top')) showLogos();
  else hideLogos(); // 中腹ロード対策（停止状態で始まる想定なら非表示）

  // 監視
  window.addEventListener('scroll', onScroll, { passive: true });
});
(function(){
  const root = document.getElementById('NavDrawer');
  if(!root) return;
  const btns = root.querySelectorAll('.mobile-nav__link--top-level');
  btns.forEach(b=>{
    const t = (b.textContent || '').trim();
    if(t === 'ご購入検討中の方へ') b.classList.add('is-guide');
    if(t === 'WOをお持ちの方へ')   b.classList.add('is-owner');
  });
})();
